
const getCartImage = (valId, productsArr) => {
    const newImg = productsArr.products?.filter(
      (item) => item.id.toString() === valId
    ).shift();
    // console.log(newImg)
    const imgToDisplay = newImg?.thumbnail;
    if(imgToDisplay) {return imgToDisplay}
  };

  export default getCartImage;